import React from "react";
import { useHistory, Link } from "react-router-dom";
import useTableMethods from "../../customHooks/useTableMethods";

//icons
import view from "../../assets/view.svg";
import pending from "../../assets/pending.svg";
import completed from "../../assets/completed.svg";
import loader from "../../assets/loader.svg";

//temp
import drink from "../../assets/products-inactive.svg";

import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
  ButtonGroup,
  Button,
  TablePagination
} from "@material-ui/core";

//components
import TableHead from "./DeclinedProductsTableHead";

const DeclinedProductRequests = ({
  rows,
  busy = false,
  notFound = false,
  search = "",
  count,
  onPageChange,
  onRowsPerPageChange,
  page,
  rowsPerPage
}) => {
  const {
    handleSelectAllClick,
    handleClick,
    isSelected,
    selected
  } = useTableMethods(rows);

  const addDefaultImage = (event) => {
    event.target.src = drink;
  }

  const history = useHistory();

  return (
    <div className="w-full mt-5">
      {busy || rows.length === 0 ? (
        <>
          <Table className="min-w-[750px]" size="small">
            <TableHead
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={rows.length}
            />
          </Table>
          <div className="bg-white w-full h-[312px] flex flex-col justify-center items-center mt-2">
            {busy || !notFound ? (
              <img src={loader} alt="loading" className="w-5 animate-spin" />
            ) : (
              <>
                <p className="text-[#3D4356] text-[18px] font-bold text-center mb-2">
                  No Search Result for "{search}"
                </p>
                <p className="text-[#8892A2] text-[14px] w-[448px] text-center font-normal">
                  <span className="text-[#8892A2] text-[14px] font-bold">
                    Search tips:{" "}
                  </span>
                  Some search terms require an exact match. Try typing the
                  entire term, or use a different word or phrase.
                </p>
              </>
            )}
          </div>
        </>
      ) : (
        <Table className="min-w-[750px]" size="small">
          <TableHead
            numSelected={selected.length}
            onSelectAllClick={handleSelectAllClick}
            rowCount={rows.length}
          />

          <TableBody className="bg-white">
            {rows.map((row, index) => {
              const isItemSelected = isSelected(index);

              return (
                <TableRow
                  hover
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={index}
                  selected={isItemSelected}
                  className="border-b-0 border-l-4 hover:border-l-orange border-transparent hover:bg-[#EEF2F5]"
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isItemSelected}
                      onClick={(event) => handleClick(event, index)}
                    />
                  </TableCell>
                  <TableCell className="flex items-center space-x-2">
                    <img className="w-8 h-8" src={row.image} alt="" onError={addDefaultImage}/>
                    <p className="text-sm font-medium text-gray2">{row.name}</p>
                  </TableCell>

                  <TableCell className="font-medium text-black" align="left">
                    {row.reason}
                  </TableCell>
                  <TableCell align="right">
                    <ButtonGroup size="medium">
                      <Button>
                        <Link to={`/products/requests/details/${row.uuid}?declined`}>
                          <img src={view} alt="view product details" />
                        </Link>
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
      {!busy && (
        <TablePagination
          rowsPerPageOptions={[10, 50, 100, 500]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page - 1}
          onPageChange={(e, newPage) => {
            onPageChange(newPage + 1);
          }}
          onRowsPerPageChange={(e) => {
            onRowsPerPageChange(e.target.value)
          }}
        />
      )}
    </div>
  );
};

export default DeclinedProductRequests;
